import { useSearchParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { getMe } from '../../../store/auth/authReducer';
import { AppDispatch } from '../../../store';
import { GridLoader, PacmanLoader } from 'react-spinners';  // Importing the spinner
import { Mixpanel } from '../../../utils/MixPanel';

const GoogleAuthCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>(); // Provide the correct type for dispatch
    const [loading, setLoading] = useState(true); // State to track loading
    const [delayOver, setDelayOver] = useState(false); // To handle delay status

    useEffect(() => {
        const token = searchParams.get('token');

        // Set a delay before dispatching the action
        const timer = setTimeout(() => {
            setDelayOver(true); // Set the delay flag to true after delay
        }, 2000); // Delay for 2 seconds

        // Dispatching action after the delay is over
        if (token && delayOver) {
            dispatch(getMe(token || ''))
                .then((response) => {
                    setLoading(false);
                    navigate('/user/dashboard', { replace: true });// Redirect to dashboard after user data is fetched
                })
                .catch((error) => {
                    console.error(error);
                    setLoading(false);
                    navigate('/auth/login', { replace: true }); // Redirect back to login if fetching user failed
                });
        }

        // Cleanup the timeout
        return () => clearTimeout(timer);
    }, [searchParams, dispatch, navigate, delayOver]);

    return (
        <div className="flex justify-center items-center h-screen">
            {loading ? (
                // Show the spinner while waiting for the user data or delay
                <PacmanLoader size={50} color="#22c55e" loading={loading} />
            ) : (
                <div>Processing complete. Redirecting...</div> // Optional message after processing
            )}
        </div>
    );
};

export default GoogleAuthCallback;
